export default [
  {pot: 'prikljucek/sms/poslji?'}
]



// WEBPACK FOOTER //
// ./src/assets/js/Enum/KriticniEndpointi.js